import React, { useEffect, useRef } from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import clsx from 'clsx';
import useStyles from 'app/cluster-styles/useStyles';
import useProviderData from '../hooks/useProviderData';

export default function ZoneSelector({ provider, regionId, value, onChange, className }) {
    const classes = useStyles();
    const { zonesForRegion } = useProviderData(provider);
    const zones = zonesForRegion(regionId);
    const prevRegionRef = useRef(regionId);

    // Cascading clear: when region changes and current zone is no longer valid, auto-clear
    useEffect(() => {
        if (prevRegionRef.current === regionId) return;
        prevRegionRef.current = regionId;

        if (!value) return;
        const stillValid = zones.some((z) => z.zone_id === value);
        if (!stillValid) {
            onChange('');
        }
    }, [regionId, zones, value, onChange]);

    const disabled = !regionId || zones.length === 0;
    const safeValue = zones.some((z) => z.zone_id === value) ? value : '';

    return (
        <TextField
            select
            className={clsx(classes.input, className || "flex-1")}
            id="rm-zone"
            name="rm_zone_id"
            label={regionId ? 'Zone' : 'Select a Region first'}
            variant="outlined"
            value={safeValue}
            onChange={(e) => onChange(e.target.value)}
            required={!disabled}
            disabled={disabled}
            SelectProps={{
                MenuProps: {
                    PaperProps: {
                        style: { maxHeight: 300 },
                    },
                },
            }}
        >
            {zones.map((zone) => (
                <MenuItem key={zone.zone_id} value={zone.zone_id}>
                    {zone.name}
                </MenuItem>
            ))}
        </TextField>
    );
}
